module.exports = __webpack_public_path__ + "static/media/game-play-bg.8b62fd38.svg";